import { useRef, useState } from 'react';
import './Input.scss';
import PropTypes from "prop-types";

const Input = ({
                   onChange,
                   name,
                   value,
                   onValidate,
                   id,
                   placeholder,
                   autoComplete,
                   disabled,
                   type,
                   onKeyDown,
                   autoFocus
               }) => {
    const [focused, setFocused] = useState(false);
    const [isValid, setIsValid] = useState(true);
    const ref = useRef(null);

    const handleFocus = () => {
        setFocused(true);
    };
    const handleOnChange = ({target: {name, value}}) => onChange(value, name);
    const handleAnimationStart = (e) => {
        switch (e.animationName) {
            case 'onAutofillStart': {
                if (ref) {
                    setFocused(true);
                }
                break;
            }
            case 'onAutofillCancel': {
                if (ref) {
                    setFocused(false);
                }
                break;
            }
            default:
                break;
        }

    }
    const handleBlur = () => {
        if (onValidate) {
            const valid = onValidate(name, value)
            if (!valid) {
                setIsValid(false);
            } else if (valid && !isValid) {
                setIsValid(true);
            }
        }
        setFocused(false);
    }

    const hasFocus = focused || value;
    const labelCls = `input-label ${hasFocus ? 'input-label--active' : ''} ${!isValid ? 'input-label--invalid' : ''}`;

    const className = [
        'input-container',
        !isValid && 'input-container--invalid',
        disabled && 'input-container--disabled'
    ].filter(value => !!value).join(' ');
    return (
        <div className={className}>
            <label className={labelCls} htmlFor={id}>
                {placeholder}
            </label>
            <input
                ref={ref}
                autoFocus={autoFocus}
                type={type}
                className="input-type"
                value={value}
                autoComplete={autoComplete || 'off'}
                id={id}
                name={name}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onChange={handleOnChange}
                onAnimationStart={handleAnimationStart}
                onKeyDown={onKeyDown}
                disabled={disabled}
            />
        </div>
    );
}

Input.propTypes = {
    onChange: PropTypes.func.isRequired,
    type: PropTypes.string,
    onKeyDown: PropTypes.func,
}

export default Input;
